import { LoggerViewModel } from './models';
import { axiosProvider } from '@/app/core/axios';
import {
  LoggerSearchResponse,
  LoggerApiSearchResponse,
  SearchRequest,
} from '@ssar-app/domain';
import { stringify } from 'qs';

const getLogs = (search: SearchRequest): Promise<LoggerSearchResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(search, qsConfig);
    axiosProvider.apiClient
      .get<LoggerApiSearchResponse>(`/logger?${query}`)
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No logs were found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getLogInfo = (id?: string): Promise<LoggerViewModel> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .get<LoggerViewModel>(`/logger/info/${id}`)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response: any) => {
        if (response.data.data.data) {
          resolve(response.data.data.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  getLogs,
  getLogInfo,
};
